import React from "react";
import styles from "../styles/SiteUpgrade.module.css";
import { FaPhoneAlt, FaEnvelope, FaFacebookF } from "react-icons/fa";
import { GiUpgrade } from "react-icons/gi";


const SiteUpgrade = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
         

          <GiUpgrade className={styles.spannerIcon}/>
    
        <h1 className={styles.title}>We&rsquo;re Upgrading Our Site</h1>

        <p className={styles.text}>
          Hodson Timber is currently undergoing an upgrade to improve your
          experience.
        </p>
        <p className={styles.text}>
          We&rsquo;ll be back shortly.
        </p>

         {/* <div className={styles.description}>Hand crafted bespoke joinery and staircases supplied and installed. </div>
          <div className={styles.descriptionSmall}>Family business established since 1953</div> */}

        <div className={styles.contact}>
          <div className={styles.contactItem}>
            <FaPhoneAlt />
            <a href="tel:01942671811">01942 671 811</a>
          </div>

          <div className={styles.contactItem}>
            <FaEnvelope />
            <a href="mailto:sales@hodsontimber.co.uk">
              sales@hodsontimber.co.uk
            </a>
          </div>

          <div className={styles.contactItem}>
            <FaFacebookF />
            <a
              href="https://www.facebook.com/hodsonsjoinery"
              target="_blank"
              rel="noopener noreferrer"
            >
              Facebook
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SiteUpgrade;